export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.1-0848.58",
  commitId: "946fb9c52353899bbeb6b69461b4f5bff75986dd",
  commitTime: "2026-09-01T08:48:58.000Z",
});
